import * as React from 'react';
import { memo } from 'react';
import { SwipeAction } from ".";
import { Icon } from '.';
import { css, colors, shadows, radius, fontSizes } from '../../style';

interface ListProps {
	itemBuilder: (index: number) => JSX.Element
	itemCount: number
}

export const List = memo(function List(props: ListProps) {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '12px' }}>
			{Array(props.itemCount).fill(null).map((_, index) => props.itemBuilder(index))}
		</div>
	);
});

interface ListTileProps {
	item?: any
	orderStatus?: any
	left?: JSX.Element
	title?: JSX.Element
	sharedBy?: JSX.Element
	right?: JSX.Element
	hidden?: JSX.Element
	hiddenWidth?: number
	style?: React.CSSProperties
	wrapperStyle?: React.CSSProperties
	/** Action to perform when the item is pressed */
	onClick?: () => any
}

export const ListTile = memo(function ListTile(props: ListTileProps) {
	const OrderNotation = () => {
		return (
			<div style={{
				position: 'absolute',
				width: '7px', height: '7px',
				borderRadius: '50%',
				backgroundColor: props.orderStatus ?
					props.orderStatus === "Tillverkad" ? "blue"
						: props.orderStatus === "Fel" ? colors.error
							: props.orderStatus === "Levererad" ? colors.warning
								: props.orderStatus === "Monterad" ? colors.success
									: colors.primary
					: "transperent",
				top: 5, left: 5
			}}
			/>
		)
	}

	const renderContent = () => {
		return (
			<>
				{props.orderStatus && <OrderNotation />}
				<div>
					{props.left}
				</div>
				<div style={{ flex: 1 }}>
					{props.title}
				</div>
				{props.sharedBy ?
					<div style={{ display: "flex", alignItems: "center" }}>
						{props.sharedBy}
					</div>
					: null}
				<div>
					{props.right}
				</div>
			</>
		)
	}

	const renderWrapper = () => {
		const style = props.wrapperStyle || {};
		if (!props.hidden) {
			return (
				<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', padding: '10px', ...style, cursor: "pointer" }}>
					{renderContent()}
				</div>
			)
		}
		const buttons = (
			<div style={{ display: 'flex', height: '100%' }}>
				{props.hidden}
			</div>
		);
		return (
			<SwipeAction
				style={{
					width: '100%', cursor: "pointer"
				}}
				right={[
					{ text: buttons }
				]}
			>
				<div style={{
					display: 'flex', width: '100%', justifyContent: 'space-between', padding: '10px',
					background: props.item && props.item.ordered ? 'var(--color-surface-raised)' : undefined,
					...style
				}}>
					{renderContent()}
				</div>
			</SwipeAction>
		)
	}

	const style = props.style || {}
	return (
		<div
			className={css.CartItem().row}
			style={style}
			onClick={props.onClick ? props.onClick.bind(null) : undefined}
		>
			{renderWrapper()}
		</div>
	);
});

export const AddItemTile = React.memo(function AddItemTile(props: { disabled?: boolean }) {
	return (
		<ListTile
			style={{ backgroundColor: colors.lightest, boxShadow: shadows.thick, cursor: "pointer" }}
			title={<div style={{ textAlign: 'center' }}><Icon type="plus-circle" theme="filled" twoToneColor={colors.lightest} style={{ fontSize: fontSizes.xl }} /></div>}
		/>
	);
});

export const AddItemTileNew = React.memo(function AddItemTileNew(props: { disabled?: boolean }) {
	return (
		<ListTile
			style={{
				backgroundColor: colors.primary, cursor: "pointer",
				boxShadow: shadows.heavy, width: 70, height: 40, borderRadius: radius.normal, marginLeft: 'auto', marginTop: 0
			}}
			title={<div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}><Icon type="plus-circle" theme="filled" twoToneColor={colors.lightest} style={{ fontSize: fontSizes.xl, color: colors.white }} /></div>}
		/>
	);
});
